import { render, staticRenderFns } from "./Men.vue?vue&type=template&id=d0f4d8a2&scoped=true&"
import script from "./Men.vue?vue&type=script&lang=js&"
export * from "./Men.vue?vue&type=script&lang=js&"
import style0 from "./Men.vue?vue&type=style&index=0&id=d0f4d8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f4d8a2",
  null
  
)

export default component.exports